import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import Preloader from "./components/landing/preloader";

import Home from "./pages/landing";
import Signin from "./pages/auth/signin";
import Signup from "./pages/auth/signup";
import ForgotPass from "./pages/auth/forgotPaswword";
import ResetPass from "./pages/auth/resetPass";
import UserDash from "./pages/account/home";
import Profile from "./pages/account/profile";
import EditProfile from "./pages/account/profile-edit";
import PassUpdate from "./pages/account/passupdate";
import TopPicks from "./pages/account/toppicks";
import Faq from "./pages/account/faq";
import PredictWinDashboard from "./pages/account/predictwin";
// import SubscriptionPayment from "./pages/account/subscription/payment";
// import PaymentSuccess from "./pages/account/subscription/payment-success";
import Adminlogin from "./pages/admin/login";
import AdminDashboard from "./pages/admin/dashboard/home";
import Allusers from "./pages/admin/dashboard/users";
// import PlansPage from "./pages/admin/dashboard/plans";
// import TransactionHistory from "./pages/admin/dashboard/transaction";
import PushCampaigns from "./pages/admin/dashboard/pushCampaigns";
import NotFound from "./pages/404";
import { Toaster } from "react-hot-toast";
import { UserProvider } from "./context/userContext";
import GoogleCallback from "./pages/auth/googleCallback";
import Policy from "./pages/policy";
import FacebookRedirectPage from "./pages/facebook";
import SignupFB from "./pages/auth/signup-fb";
// import CryptoRequest from "./pages/admin/dashboard/crypto";
import ReferralDashboard from "./pages/account/refferals";
// import WithdrawalWithAuth from "./pages/account/withdraw";
import More from "./pages/more";
import MobileSignup from "./pages/auth/mobile-signup";
import IndividualMatchDetails from "./pages/account/match-details";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PredictWinAdmin from "./pages/admin/dashboard/predictwin";
import { PushNotificationBanner } from "./components/PushNotificationManager";
// Meta Pixel Component
const MetaPixel = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      // Optionally, track custom events for specific routes
      if (location.pathname.startsWith("/account")) {
        window.fbq("trackCustom", "UserRouteVisit", { path: location.pathname });
      }
    }
  }, [location]); // Trigger on route change

  return (
    <Helmet>
      <script>
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '3642299099339997');
        `}
      </script>
      <noscript>
        {`
          <img 
            height="1" 
            width="1" 
            style="display:none"
            src="https://www.facebook.com/tr?id=3642299099339997&ev=PageView&noscript=1"
          />
        `}
      </noscript>
    </Helmet>
  );
};

const Layout = ({ children }) => {
  return (
    <>
      <Toaster />
      <Preloader />
      {children}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

function App() {
  return (
    <UserProvider>
      <Router>
        <MetaPixel /> {/* Add Meta Pixel tracking */}
        <Layout>
          <div className="pb-16">
            <PWAInstallPrompt />
            <PushNotificationBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth/signin" element={<Signin />} />
              <Route path="/auth/signup" element={<Signup />} />
              <Route path="/auth/forgot-password" element={<ForgotPass />} />
              <Route path="/auth/reset-password" element={<ResetPass />} />
              <Route path="/auth/complete-reg" element={<SignupFB />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/auth/mobile-signup" element={<MobileSignup />} />
              <Route path="/account/home" element={<UserDash />} />
              <Route path="/account/profile" element={<Profile />} />
              <Route path="/account/profile-edit" element={<EditProfile />} />
              <Route path="/account/password-update" element={<PassUpdate />} />
              <Route path="/account/top-picks" element={<TopPicks />} />
              <Route path="/account/referrals" element={<ReferralDashboard/>} />
              <Route path="/account/predictwin" element={<PredictWinDashboard/>} />
              {/* Payment/Subscription system disabled */}
              {/* <Route path="/account/withdraw" element={<WithdrawalWithAuth/>} /> */}
              <Route path="/account/faq" element={<Faq />} />
              {/* <Route
                path="/account/subscription/payment"
                element={<SubscriptionPayment />}
              /> */}
              {/* <Route
                path="/account/subscription/payment-success"
                element={<PaymentSuccess />}
              /> */}
              {/* <Route
                path="/account/subscription/crypto-payment-success"
                element={<PaymentSuccess />}
              /> */}
              <Route path="/twzpanel" element={<Adminlogin />} />
              <Route path="/twzpanel/dashboard" element={<AdminDashboard />} />
              <Route path="/twzpanel/dashboard/users" element={<Allusers />} />
              {/* <Route path="/twzpanel/dashboard/plans" element={<PlansPage />} /> */}
              <Route path="/twzpanel/dashboard/push-campaigns" element={<PushCampaigns />} />
              <Route path="/twzpanel/dashboard/predictwin" element={<PredictWinAdmin/>} />
              {/* <Route
                path="/twzpanel/dashboard/transaction-history"
                element={<TransactionHistory />}
              /> */}
              <Route path="*" element={<NotFound />} />
              <Route path="/policies" element={<Policy />} />
              <Route path="/facebook-redirect" element={<FacebookRedirectPage />} />
              {/* <Route path="/twzpanel/crypto-requests" element={<CryptoRequest />} /> */}
              <Route path="/more" element={<More />} />
              <Route path="/match-details" element={<IndividualMatchDetails />} />

            </Routes>
          </div>
        </Layout>
      </Router>
    </UserProvider>
  );
}

export default App;
